import styled from "styled-components";
import { palette } from "styled-theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;

  .animated-gif-clipboard {
    max-width: 80px;
  }

  .attention-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    padding: 10px 20px 45px;
    background-color: ${palette("color", 15)};
    border-radius: 25px;

    h3 {
      color: ${palette("tracking", 1)};
      text-align: center;
    }

    p {
      color: #fff;
    }
  }

  h3 {
    color: ${palette("color", 15)};
    padding-top: 10px;
    text-align: center;
  }

  p {
    text-align: center;
    padding-top: 20px;
  }
`;
